<template>
  <div class="flex justify-around border-t py-2">
    <TabBarItem
      :name="t('mainTabbar.search')"
      :is-active="isActive(App.SEARCH)"
      @click="handleTabbarItemClick(App.SEARCH)"
    >
      <!-- prettier-ignore -->
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" fill="none"><path fill="currentColor" d="M12.69 14.56a1.5 1.5 0 0 1 2.12-2.12l5.38 5.378a1.5 1.5 0 1 1-2.122 2.121l-5.379-5.378Z"/><path fill="currentColor" fill-rule="evenodd" d="M8.75 17a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Zm0-3a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z" clip-rule="evenodd"/><defs><linearGradient id="a" x1="10.5" x2="20.185" y1="8.5" y2="22.616" gradientUnits="userSpaceOnUse"><stop stop-color="#40B160"/><stop offset="1" stop-color="#40B160" stop-opacity="0"/></linearGradient></defs></svg>
    </TabBarItem>
    <TabBarItem
      :name="t('mainTabbar.cabinet')"
      :is-active="isActive(App.CABINET)"
      @click="handleTabbarItemClick(App.CABINET)"
    >
      <!-- prettier-ignore -->
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M4.531 0a4 4 0 0 0-4 4v13a4 4 0 0 0 4 4h12V0h-12Zm1.36 12.505a.447.447 0 0 0 0 .893h5.359a.447.447 0 1 0 0-.893H5.89Zm-.447 2.287a.5.5 0 0 1 .5-.5h5.253a.5.5 0 0 1 .5.5v.786a.5.5 0 0 1-.5.5H5.944a.5.5 0 0 1-.5-.5v-.786Zm.5-9.433a.5.5 0 0 0-.5.5v.787a.5.5 0 0 0 .5.5h5.253a.5.5 0 0 0 .5-.5v-.787a.5.5 0 0 0-.5-.5H5.944Zm-.5 4.913c0-.247.2-.446.447-.446h5.359a.447.447 0 1 1 0 .893H5.89a.447.447 0 0 1-.446-.447Zm.447-2.233a.447.447 0 0 0 0 .893h5.359a.447.447 0 1 0 0-.893H5.89Z" clip-rule="evenodd"/><rect width="3" height="21" x="18.969" fill="currentColor" rx="1.5"/><defs><linearGradient id="a" x1=".743" x2="16.635" y1="18.367" y2="6.246" gradientUnits="userSpaceOnUse"><stop stop-color="#A8ACB1"/><stop offset="1" stop-color="#A8ACB1"/></linearGradient><linearGradient id="b" x1="22" x2="14" y1="-1.5" y2="25" gradientUnits="userSpaceOnUse"><stop stop-color="#D5D7D9"/><stop offset="1" stop-color="#D5D7D9" stop-opacity="0"/></linearGradient></defs></svg>
    </TabBarItem>
    <TabBarItem
      :name="t('mainTabbar.passengers')"
      :is-active="isActive(App.PASSENGERS)"
      @click="handleTabbarItemClick(App.PASSENGERS)"
    >
      <!-- prettier-ignore -->
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" fill="none"><g clip-path="url(#a)"><path fill="currentColor" d="M7.6 12.6a5.25 5.25 0 0 0-5.25 5.25A3.15 3.15 0 0 0 5.5 21H16a3.15 3.15 0 0 0 3.15-3.15 5.25 5.25 0 0 0-5.25-5.25H7.6Z"/><path fill="currentColor" d="M10.75 0a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5Z"/></g><defs><linearGradient id="b" x1="17.929" x2="11.022" y1="13.095" y2="27.66" gradientUnits="userSpaceOnUse"><stop stop-color="#D5D7D9"/><stop offset="1" stop-color="#D5D7D9" stop-opacity="0"/></linearGradient><linearGradient id="c" x1="5.639" x2="13.879" y1="9.183" y2=".936" gradientUnits="userSpaceOnUse"><stop stop-color="#A8ACB1"/><stop offset="1" stop-color="#A8ACB1"/></linearGradient><clipPath id="a"><path fill="#fff" d="M.25 0h21v21h-21z"/></clipPath></defs></svg>
    </TabBarItem>
    <TabBarItem
      :name="t('mainTabbar.bank')"
      @click="handleMiniAppLeaveClick"
    >
      <!-- prettier-ignore -->
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M12.25 21a1.5 1.5 0 0 1 0-3h6.5V3h-6.5a1.5 1.5 0 0 1 0-3h8a1.5 1.5 0 0 1 1.5 1.5v18a1.5 1.5 0 0 1-1.5 1.5h-8Z" clip-rule="evenodd"/><path fill="#A8ACB1" fill-rule="evenodd" d="M1.312 11.692a1.046 1.046 0 0 1-.12-.098 1.639 1.639 0 0 1-.332-.535 1.691 1.691 0 0 1-.11-.543v.052-.053.001a1.773 1.773 0 0 1 0-.031v-.053.051a1.69 1.69 0 0 1 .11-.543c.076-.199.189-.38.332-.534.038-.036.078-.069.12-.098l5.677-4.89a.88.88 0 0 1 .97-.128c.157.077.29.199.383.351.093.153.143.33.144.51v3.032a.745.745 0 0 0 .203.51.685.685 0 0 0 .488.207h5.982c.21 0 .417.043.61.127.194.084.37.207.517.362a1.669 1.669 0 0 1 .45.957.723.723 0 0 1 .014.097v.042-.019a1.87 1.87 0 0 1 0 .068v-.019.042-.023a.72.72 0 0 1-.014.12 1.67 1.67 0 0 1-.45.957 1.589 1.589 0 0 1-.517.361c-.193.084-.4.128-.61.128H9.177a.661.661 0 0 0-.488.208.719.719 0 0 0-.203.509v3.031c0 .181-.05.358-.144.51a.929.929 0 0 1-.383.352.88.88 0 0 1-.97-.129l-5.677-4.889Z" clip-rule="evenodd"/><defs><linearGradient id="a" x1="19.655" x2="6.228" y1="16.82" y2="10.13" gradientUnits="userSpaceOnUse"><stop stop-color="#D5D7D9"/><stop offset="1" stop-color="#D5D7D9" stop-opacity="0"/></linearGradient></defs></svg>
    </TabBarItem>
    <FakePageLoader v-if="isMiniAppLoading" />
  </div>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import { useI18n } from 'vue-i18n';

  import { freedomApp } from '../../../entities/freedom-app';
  import { FakePageLoader } from '../../../entities/fake-page-loader';
  import { appNavLinks } from '../../../shared/lib';
  import { FlowType, App } from '../../../shared/config';
  import TabBarItem from './TabBarItem.vue';

  const emit = defineEmits<{ onMiniAppLeave: [] }>();

  const props = withDefaults(
    defineProps<{
      defaultActiveApp?: App;
      searchAppType?: FlowType;
    }>(),
    {
      defaultActiveApp: App.SEARCH,
      searchAppType: FlowType.AVIA,
    },
  );

  const activeTab = ref(props.defaultActiveApp);
  const isMiniAppLoading = ref(false);

  const { t } = useI18n();

  const openSearchApp = () => {
    if (props.searchAppType === FlowType.AVIA) {
      appNavLinks.openAvia(props.defaultActiveApp);
    } else if (props.searchAppType === FlowType.RAILWAYS) {
      appNavLinks.openRailways(props.defaultActiveApp);
    }
  };

  const isActive = (miniAppName: App) => miniAppName === activeTab.value;

  const handleTabbarItemClick = (miniAppName: App) => {
    isMiniAppLoading.value = true;

    switch (miniAppName) {
      case App.SEARCH:
        openSearchApp();
        break;
      case App.CABINET:
        appNavLinks.openCabinet(props.searchAppType);
        break;
      case App.PASSENGERS:
        appNavLinks.openPassengers(props.searchAppType);
        break;
    }
  };

  const handleMiniAppLeaveClick = () => {
    emit('onMiniAppLeave');
    freedomApp.lib.backToApp();
  };
</script>

<i18n src="../config/locales.json"></i18n>
